import useFeatureFlag from '@customHooks/useFeatureFlag';
import ProfileSalaryInfo from '@atoms/ProfileInformation';
import ProfileNotifications from '@atoms/ProfileNotifications';
import ProfilePhoneEnroll from '@atoms/ProfilePhoneEnroll';
import { Divider, Text, View } from '@components/primitives';
import appStyles from '@root/appStyles';
import { FEATURE_FLAGS } from '@root/constants';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ProfileInformationProps = {
  showPhoneEnroll?: boolean;
  showSalaryInfo?: boolean;
};

function ProfileInformation({ showPhoneEnroll = false, showSalaryInfo = false }: ProfileInformationProps) {
  const { t } = useTranslation('common');
  const [isFeatureAvailable] = useFeatureFlag({ featureName: [FEATURE_FLAGS.NOTIFI_CENTRE] });
  const showNotifications = isFeatureAvailable?.[FEATURE_FLAGS.NOTIFI_CENTRE]?.show;

  return (
    <>
      <View style={[appStyles.marginLeft(16), { borderWidth: 0, overflow: 'hidden' }]} marginY="16px">
        <Text testID="txtProfileInformation" variant="md-bold">
          {t('profile.information')}
        </Text>
        <ProfilePhoneEnroll showPhoneEnroll={showPhoneEnroll} />
        <ProfileSalaryInfo showSalaryInfo={showSalaryInfo} />
        {showNotifications ? (
          <>
            <Text testID="txtProfileSettings" marginTop="16px" variant="md-bold">
              {t('profile.settings')}
            </Text>
            <ProfileNotifications showNotifications={showNotifications} />
          </>
        ) : null}
      </View>
      <Divider height="4px" style={{ backgroundColor: colors.neutral.mist }} />
    </>
  );
}

export default ProfileInformation;
